import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {CommonsModule} from "../../commons/angular/commons.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {TranslateModule} from "@ngx-translate/core";
import {NgxPermissionsModule} from "ngx-permissions";


@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild()
  ],
  providers: [],
  exports: []
})

export class ItinerariesModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapItinerariesModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(ItinerariesModule);
};

export const downgradedItinerariesModule = downgradeModule(bootstrapItinerariesModule);
